import * as React from "react";
import { useEffect } from "react";
import "../../proposols/step1/proposol.css";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { set_info1 } from "../../../Redux/action";
import {
  Col,
  Form,
  Input,
  Row,
  Select,
  Button,
  InputNumber,
  Collapse,
} from "antd/lib";
import axios from "axios";
import SelfProposerdisplay from "../InfoDisplay/SelfProposerDisplay";
import { EditOutlined } from "@ant-design/icons";
function SelfPropDetail({ setShowSelfDisplay, ShowSelfDisplay, isAllPresent }) {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { Panel } = Collapse;
  const [formLayout] = useState("vertical");
  const dispatch = useDispatch();
  const history = useHistory();
  const reg = useSelector((state) => state?.healthdetail?.healthnum);
  const OwnerInfo = useSelector((state) => state?.addressdetail?.info1);
  const PersonsDetail = useSelector(
    (state) => state?.healthdetail?.famdetail?.healthdetail
  );
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeKey, setActiveKey] = useState(["1", "2"]);

  useEffect(() => {
    setShowSelfDisplay(isAllPresent);
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    const url = `${BASEURL}states`;
    const config = {
      headers: {
        Authorization: "Bearer " + reg.token,
      },
    };
    axios
      .get(url, config)
      .then((res) => {
        const resp = res?.data?.data;
        const statesArray = Object.keys(resp).map((id) => ({
          id,
          label: resp[id],
        }));
        setOptions(statesArray);
      })
      .catch((err) => {
        console.log(err?.response);
      });
  }, [isAllPresent]);

  const onFinish = (values) => {
    setLoading(true);
    // console.log(values)
    var Self = {
      title: values?.title,
      SelfName: values?.fullName,
      Mobile: values?.MobileNumber,
      Email: values?.email,
      bloodGroup: values?.bloodGroup,
      height: values?.height,
      inches: values?.inches,
      weight: values?.weight,
      Address: values?.address,
      City: values?.city,
      State: values.state,
      Pincode: values?.pincode,
    };
    // console.log(data)
    dispatch(set_info1({ ...OwnerInfo, Self }));
    setTimeout(() => {
      setLoading(false);
      setShowSelfDisplay(true);
      //   setShowStep2(true)
      //   Ref2.current?.scrollIntoView({ behavior: "smooth" });
      //history.push("/step2");
    }, 500);
  };

  //   console.log(PersonsDetail)
  const onChange = (keys) => {
    console.log(keys);
    setActiveKey(keys);
  };
  const EditSelf = () => {
    setShowSelfDisplay(false);
  };
  return (
    <>
      {ShowSelfDisplay ? (
        <>
          <div className="edit-prop-detail">
            <EditOutlined onClick={EditSelf} />
          </div>
          <SelfProposerdisplay />
        </>
      ) : (
        <div className="gridparent-skb">
          <Form
            layout={formLayout}
            form={form}
            style={{ paddingTop: "10px" }}
            //requiredMark={false}
            onFinish={onFinish}
            scrollToFirstError
          >
            <Row gutter={24}>
              <Col span={3}>
                <Form.Item
                  label="Title"
                  name="title"
                  rules={[
                    {
                      required: true,
                      message: "please Select title",
                    },
                  ]}
                  initialValue={OwnerInfo?.Self?.title}
                >
                  <Select
                    placeholder="Mr/Mrs"
                    options={[
                      {
                        value: "Mr",
                        label: "Mr",
                      },
                      {
                        value: "Mrs",
                        label: "Mrs",
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col span={9}>
                {/* <Form.Item 
                    label="Full Name (as per PAN)"
                    name='fullName'
                    rules={[{
                    required: true, 
                    message: 'please input Name'
                  }]}
                  initialValue={OwnerInfo?.Self?.Owner}
                  >
                  <Input
                    style={{width: "100%"}}
                    placeholder="Full Name" 
                  />
                  </Form.Item> */}
                <Form.Item
                  label="Full Name"
                  name="fullName"
                  rules={[
                    {
                      required: true,
                      message: "Please input your name",
                    },
                    {
                      validator: (_, value) => {
                        const nameParts = value.trim().split(" "); // Trim whitespace and split the name

                        // Check if there are at least two parts (first name and second name/initial)
                        if (nameParts.length < 2) {
                          return Promise.reject(
                            "Please enter your full name with a second name or initial."
                          );
                        }

                        // Check if the last part is not just a dot
                        if (nameParts[nameParts.length - 1] === ".") {
                          return Promise.reject(
                            "Please enter a valid second name or initial."
                          );
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  initialValue={OwnerInfo?.Self?.Owner}
                >
                  <Input style={{ width: "100%" }} placeholder="Full Name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  // {...formItemLayout}
                  label="Mobile Number"
                  name="MobileNumber"
                  rules={[
                    {
                      required: true,
                      // type: 'number',
                      message: "please input Mobile Number",
                    },
                  ]}
                  initialValue={OwnerInfo?.Self?.Mobile}
                >
                  <Input
                    style={{ width: "100%" }}
                    placeholder="Mobile Number"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item
                  // {...formItemLayout}
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "Please Input Email",
                    },
                  ]}
                  initialValue={OwnerInfo?.Self?.Email}
                >
                  <Input
                    autoComplete="off"
                    style={{ width: "100%" }}
                    placeholder="Email"
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  label="Blood Group"
                  name="bloodGroup"
                  rules={[
                    {
                      required: true,
                      message: "please Select Blood Group",
                    },
                  ]}
                  initialValue={OwnerInfo?.Self?.bloodGroup}
                >
                  <Select
                    placeholder="Blood group"
                    options={[
                      {
                        value: "A+",
                        label: "A+",
                      },
                      {
                        value: "A-",
                        label: "A-",
                      },
                      {
                        value: "B+",
                        label: "B+",
                      },
                      {
                        value: "B-",
                        label: "B-",
                      },
                      {
                        value: "AB+",
                        label: "AB+",
                      },
                      {
                        value: "AB-",
                        label: "AB-",
                      },
                      {
                        value: "O+",
                        label: "0+",
                      },
                      {
                        value: "O-",
                        label: "0-",
                      },
                      {
                        value: "Not Provided",
                        label: "Not Provided",
                      },
                      {
                        value: "Not Available",
                        label: "Not Available",
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  label="Height"
                  name="height"
                  rules={[
                    {
                      required: true,
                      message: "please Select Height",
                    },
                  ]}
                  initialValue={OwnerInfo?.Self?.height}
                >
                  <Select
                    placeholder="ft"
                    options={[
                      {
                        value: "1 feet",
                        label: "1 feet",
                      },
                      {
                        value: "2 feet",
                        label: "2 feet",
                      },
                      {
                        value: "3 feet",
                        label: "3 feet",
                      },
                      {
                        value: "4 feet",
                        label: "4 feet",
                      },
                      {
                        value: "5 feet",
                        label: "5 feet",
                      },
                      {
                        value: "6 feet",
                        label: "6 feet",
                      },
                      {
                        value: "7 feet",
                        label: "7 feet",
                      },
                      {
                        value: "8 feet",
                        label: "8 feet",
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  label="Inches"
                  name="inches"
                  rules={[
                    {
                      required: true,
                      message: "please Select Inches",
                    },
                  ]}
                  initialValue={OwnerInfo?.Self?.inches}
                >
                  <Select
                    placeholder="inches"
                    options={[
                      {
                        value: "0 inches",
                        label: "0 inches",
                      },
                      {
                        value: "1 inches",
                        label: "1 inches",
                      },
                      {
                        value: "2 inches",
                        label: "2 inches",
                      },
                      {
                        value: "3 inches",
                        label: "3 inches",
                      },
                      {
                        value: "4 inches",
                        label: "4 inches",
                      },
                      {
                        value: "5 inches",
                        label: "5 inches",
                      },
                      {
                        value: "6 inches",
                        label: "6 inches",
                      },
                      {
                        value: "7 inches",
                        label: "7 inches",
                      },
                      {
                        value: "8 inches",
                        label: "8 inches",
                      },
                      {
                        value: "9 inches",
                        label: "9 inches",
                      },
                      {
                        value: "10 inches",
                        label: "10 inches",
                      },
                      {
                        value: "11 inches",
                        label: "11 inches",
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  label="Weight"
                  name="weight"
                  rules={[
                    {
                      required: true,
                      message: "please Enter Weight",
                    },
                  ]}
                  initialValue={OwnerInfo?.Self?.weight}
                >
                  <InputNumber
                    style={{ width: "100%", padding: "4px" }}
                    formatter={(value) => `${value}kg`}
                    parser={(value) => value.replace("kg", "")}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="Address"
                  name="address"
                  rules={[
                    {
                      required: true,
                      message: "please input Address",
                    },
                  ]}
                  initialValue={OwnerInfo?.Self?.Address}
                >
                  <TextArea
                    rows={1}
                    style={{ width: "100%" }}
                    placeholder="Address"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  // {...formItemLayout}
                  label="City"
                  name="city"
                  rules={[
                    {
                      required: true,
                      message: "please input City",
                    },
                  ]}
                  initialValue={OwnerInfo?.Self?.City}
                >
                  <Input
                    style={{ width: "100%" }}
                    placeholder="City/District"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="state"
                  label="state"
                  rules={[
                    {
                      required: true,
                      message: "Please select State",
                    },
                  ]}
                  initialValue={OwnerInfo?.Self?.State}
                >
                  <Select
                    defaultValue="Search for a state"
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                    options={options?.map((p) => ({
                      value: p.label,
                      label: p.label,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  // {...formItemLayout}
                  label="Pincode"
                  name="pincode"
                  rules={[
                    {
                      required: true,
                      message: "please input Pincode",
                    },
                  ]}
                  initialValue={OwnerInfo?.Self?.Pincode}
                >
                  <Input style={{ width: "100%" }} placeholder="Pincode" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}></Col>
              <Col span={24}>
                <Form.Item style={{ textAlign: "center" }}>
                  {ShowSelfDisplay ? null : (
                    <Button
                      loading={loading}
                      style={{ background: "#293890", border: "#293890" }}
                      type="primary"
                      htmlType="submit"
                    >
                      Save Self Details
                    </Button>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      )}
    </>
  );
}

export { SelfPropDetail };
